// extracted by mini-css-extract-plugin
export default {"mCard":"ez-z","image":"fz-z","imageNoBackground":"gz-z","fullWidth":"hz-z"};